<template>
  <div class="mt-6 mb-4">
    <v-container class="my-2 mx-auto">
      <v-table class="table-border">
        <thead>
        <tr>
          <th colspan="4" class="h5 font-weight-bold py-3 title text-center">
            {{ i18n.global.t('pages.safeDrivingSetting.form.deductionSettings') }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr class="border">
          <th
              :rowspan="windowInnerWidth > 800 ? 2 : 4"
              class="select-title px-2 col-1"
          >
            {{ i18n.global.t('pages.safeDrivingSetting.form.speedDeduction') }}
          </th>
          <td
              :rowspan="windowInnerWidth > 800 ? 2 : 4"
              :class="windowInnerWidth > 800 ? 'col-2' : 'col-2 center'"
          >
            <v-radio-group row="true" v-model="checked">
              <v-radio
                  :class="
                    windowInnerWidth > 800
                      ? 'radio-button'
                      : 'radio-button pb-12'
                  "
                  value="times"
                  :label="i18n.global.t('pages.safeDrivingSetting.form.alertDetection')"
                  color="blue"
                  :checked="checked == 'times'"
              />
              <v-radio
                  :class="
                    windowInnerWidth > 800
                      ? 'pt-7 radio-button'
                      : 'radio-button pt-12'
                  "
                  value="seconds"
                  :label="i18n.global.t('pages.safeDrivingSetting.form.secondsOverSpeed')"
                  color="blue"
                  :checked="checked == 'seconds'"
              />
            </v-radio-group>
          </td>
          <td class="col-4">
            <div class="pa-3">
              <v-select
                  :items="options"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.inTimes')"
                  v-model="settings.overSpeedTimes"
                  :clearable="false"
              />
            </div>
          </td>
          <td class="col-4" v-show="windowInnerWidth > 800">
            <div class="pa-3">
              <v-select
                  :items="options"
                  v-model="settings.overSpeedTimesScore"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.pointsDeduction')"
                  :clearable="false"
              />
            </div>
          </td>
        </tr>
        <tr class="border" v-show="windowInnerWidth <= 800">
          <td>
            <div class="pa-3">
              <v-select
                  :items="options"
                  v-model="settings.overSpeedTimesScore"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.pointsDeduction')"
                  :clearable="false"
              />
            </div>
          </td>
        </tr>
        <tr class="border">
          <td class="col-4">
            <div class="pa-3">
              <v-select
                  :items="OverSpeedSecondsOption"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.inSeconds')"
                  v-model="settings.overSpeedSeconds"
                  :clearable="false"
              />
            </div>
          </td>
          <td class="col-4 pb-2" v-show="windowInnerWidth > 800">
            <div class="pa-3">
              <v-select
                  :items="options"
                  v-model="settings.overSpeedSecondsScore"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.pointsDeduction')"
                  :clearable="false"
              />
            </div>
          </td>
        </tr>
        <tr class="border" v-show="windowInnerWidth <= 800">
          <td>
            <div class="pa-3">
              <v-select
                  :items="options"
                  v-model="settings.overSpeedSecondsScore"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.pointsDeduction')"
                  :clearable="false"
              />
            </div>
          </td>
        </tr>

        <tr class="border">
          <th
              :rowspan="windowInnerWidth > 800 ? 1 : 2"
              class="col-1 px-2 select-title"
          >
            {{ i18n.global.t('pages.safeDrivingSetting.form.decelerationDeduction') }}
          </th>
          <td
              :rowspan="windowInnerWidth > 800 ? 1 : 2"
              class="col-2 sub-title"
          >
            {{ i18n.global.t('pages.safeDrivingSetting.form.alertDetection') }}
          </td>
          <td class="pt-3 col-4">
            <div class="pa-3">
              <v-select
                  :items="options"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.inTimes')"
                  v-model="settings.decelerationTimes"
                  :clearable="false"
              />
            </div>
          </td>
          <td class="col-4 pb-2" v-show="windowInnerWidth > 800">
            <div class="pa-3">
              <v-select
                  :items="options"
                  v-model="settings.decelerationScore"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.pointsDeduction')"
                  :clearable="false"
              />
            </div>
          </td>
        </tr>
        <tr class="border" v-show="windowInnerWidth <= 800">
          <td>
            <div class="pa-3">
              <v-select
                  :items="options"
                  v-model="settings.decelerationScore"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.pointsDeduction')"
                  :clearable="false"
              />
            </div>
          </td>
        </tr>

        <tr class="border">
          <th
              :rowspan="windowInnerWidth > 800 ? 1 : 2"
              class="col-1 px-2 select-title"
          >
            {{ i18n.global.t('pages.safeDrivingSetting.form.accelerationDeduction') }}
          </th>
          <td
              :rowspan="windowInnerWidth > 800 ? 1 : 2"
              class="col-2 sub-title"
          >
            {{ i18n.global.t('pages.safeDrivingSetting.form.alertDetection') }}
          </td>
          <td class="pt-3 col-4">
            <div class="pa-3">
              <v-select
                  :items="options"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.inTimes')"
                  v-model="settings.accelerationTimes"
                  :clearable="false"
              />
            </div>
          </td>
          <td class="col-4 pb-2" v-show="windowInnerWidth > 800">
            <div class="pa-3">
              <v-select
                  :items="options"
                  v-model="settings.accelerationScore"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.pointsDeduction')"
                  :clearable="false"
              />
            </div>
          </td>
        </tr>
        <tr class="border" v-show="windowInnerWidth <= 800">
          <td>
            <div class="pa-3">
              <v-select
                  :items="options"
                  v-model="settings.accelerationScore"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.pointsDeduction')"
                  :clearable="false"
              />
            </div>
          </td>
        </tr>

        <tr class="border">
          <th
              :rowspan="windowInnerWidth > 800 ? 1 : 2"
              class="col-1 px-2 select-title"
          >
            {{ i18n.global.t('pages.safeDrivingSetting.form.turningDeduction') }}
          </th>
          <td
              :rowspan="windowInnerWidth > 800 ? 1 : 2"
              class="col-2 sub-title"
          >
            {{ i18n.global.t('pages.safeDrivingSetting.form.alertDetection') }}
          </td>
          <td class="pt-3 col-4">
            <div class="pa-3">
              <v-select
                  :items="options"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.inTimes')"
                  v-model="settings.sharpSteeringWheelTimes"
                  :clearable="false"
              />
            </div>
          </td>
          <td class="col-4 pb-2 pr-0" v-show="windowInnerWidth > 800">
            <div class="pa-3">
              <v-select
                  :items="options"
                  v-model="settings.sharpSteeringWheelScore"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.pointsDeduction')"
                  :clearable="false"
              />
            </div>
          </td>
        </tr>
        <tr class="border" v-show="windowInnerWidth <= 800">
          <td class="pb-2">
            <div class="pa-3">
              <v-select
                  :items="options"
                  v-model="settings.sharpSteeringWheelScore"
                  :suffix="i18n.global.t('pages.safeDrivingSetting.form.pointsDeduction')"
                  :clearable="false"
              />
            </div>
          </td>
        </tr>
        </tbody>
      </v-table>
    </v-container>
  </div>
</template>

<script>
import i18n from '@/lang/i18n';

export default {
  setup() {
    return {
      i18n
    }
  },
  props: {
    modelValue: {},
    windowInnerWidth: Number,
  },
  data() {
    return {
      settings: {},
      demeritSetting: {},
      checked: '',
      options: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
      ],
      OverSpeedSecondsOption: [
        '10',
        '20',
        '30',
        '40',
        '50',
        '60',
        '70',
        '80',
        '90',
        '100',
      ],
    };
  },
  methods: {
    initialValue() {
      if (this.modelValue && this.modelValue != null) {
        const settings = this.modelValue;
        this.checked = 'times';
        if (!settings.over_speed?.times) {
          this.checked = 'seconds';
        }

        settings['overSpeedTimes'] =
          settings && settings.over_speed.times
            ? settings.over_speed.times
            : '1';
        settings['overSpeedTimesScore'] = settings.over_speed.times
          ? settings.over_speed.score
          : '1';
        settings['overSpeedSeconds'] = settings.over_speed.seconds
          ? settings.over_speed.seconds
          : '10';
        settings['overSpeedSecondsScore'] = settings.over_speed.seconds
          ? settings.over_speed.score
          : '1';
        settings['decelerationTimes'] = settings.rapid_deceleration.times
          ? settings.rapid_deceleration.times
          : '1';
        settings['decelerationScore'] = settings.rapid_deceleration.score
          ? settings.rapid_deceleration.score
          : '1';
        settings['accelerationTimes'] = settings.rapid_acceleration.times
          ? settings.rapid_acceleration.times
          : '1';
        settings['accelerationScore'] = settings.rapid_acceleration.score
          ? settings.rapid_acceleration.score
          : '1';
        settings['sharpSteeringWheelTimes'] = settings.sharp_steering_wheel
          .times
          ? settings.sharp_steering_wheel.times
          : '1';
        settings['sharpSteeringWheelScore'] = settings.sharp_steering_wheel
          .score
          ? settings.sharp_steering_wheel.score
          : '1';

        this.settings = settings;
      }
      return this.settings;
    },
    changeSettingsValue() {
      this.$emit('update:modelValue', this.settings);
    },
  },
  watch: {
    modelValue: {
      handler() {
        if (this.modelValue) {
          this.initialValue();
        }
      },
    },
    settings: {
      handler() {
        this.changeSettingsValue();
      },
      deep: true,
    },
    checked: {
      handler() {
        this.settings['checked'] = this.checked;
      },
    },
  },
};
</script>

<style>
.title {
  border-bottom: 2px solid #dee2e6;
}
.table-border {
  border: 2px solid #dee2e6;
}
.center {
  vertical-align: middle;
}
.select-title {
  border-right: 2px solid #dee2e6;
  vertical-align: middle;
}
.radio-button {
  color: #212529;
}
.sub-title {
  vertical-align: middle;
  font-size: 16px;
  padding-left: 20px;
  color: #00000099;
}
</style>
